import React from 'react';

import { App as AppCore } from '@core/js/components/system/App/App';

import { useBeforeInitHooks } from '@interlayer/js/components/system/App/sun/hooks/useBeforeInitHooks';

export const App = ({ children }) => {
    useBeforeInitHooks();

    return (
        <AppCore>
            {children}
        </AppCore>
    );
};

